import { microphoneKeys } from './constants'

import { createEventEmitter } from '../event'

export const microphoneEventEmitter = createEventEmitter()

export const emitSpeakerVolume = (uuid, volume) => {
    microphoneEventEmitter.emit(microphoneKeys.SPEAKER_VOLUME, {
        uuid,
        volume,
    })
}

export const emitSpeakingOnMute = value => {
    microphoneEventEmitter.emit(microphoneKeys.SPEAKING_ON_MUTE, value)
}
